import { useState, useEffect } from 'react'

import fetcher from '../services/fetcher'
import log from '../services/log'

function useCurrencies(){
  const [currencies, setCurrencies] = useState(null)

  useEffect(() => {
    const getCurrencies = async () => {
      const currencies = await fetcher.getCurrencies()
      log.traceTag('currencies', currencies)
      setCurrencies(currencies)
    }

    getCurrencies();
  }, [])

  return currencies;
}

export default useCurrencies;
